<template>
  <div class="filters bg-gray q-pa-md q-mb-md">
    <div class="row q-col-gutter-md items-center">
      <div class="col-3">
        <q-input v-model="searchSync" label="Search" hint="Search by name, business name or email" />
      </div>

      <div class="col-3">
        <q-select v-model="sortSync" emit-value map-options hint="" label="Sort" :options="options" />
      </div>

      <div class="col-6 q-gutter-md">
        <q-btn outline color="primary" icon="cached" label="reset" @click="$emit('click:reset')" />
        <q-btn color="primary" icon="search" label="search" @click="$emit('click:search')" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sort: {
      type: String,
      required: true,
    },
    search: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      options: [
        { label: 'Newest', value: 'DESC' },
        { label: 'Oldest', value: 'ASC' },
      ],
    };
  },

  computed: {
    sortSync: {
      get() {
        return this.sort;
      },
      set(val) {
        return this.$emit('update:sort', val);
      },
    },
    searchSync: {
      get() {
        return this.search;
      },
      set(val) {
        return this.$emit('update:search', val);
      },
    },
  },
};
</script>
